import React, { ReactElement } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';

type IRippleCircleProps = IParentProps & {
    color: string;
};

export function RippleCircle (props: IRippleCircleProps): ReactElement {
    const { color, children }: IRippleCircleProps = props;

    return (
        <circle cx="50" cy="50" r="0" fill="none" stroke={color} strokeWidth="3">
            {children}
        </circle>
    );
}
